import React from 'react'
import SubscriptionStatus from '../stripe/SubscriptionStatus'

export default function Subscription() {
  return (
    <SubscriptionStatus />
  )
}
